import { MARKETING_EMBED_NAV_CSS_ID } from './MarketingNav.constants';
export function getWindowLocation() {
  return window.location;
}
export function getMarketingEmbedNavLocale(lang) {
  switch (lang) {
    case 'pt':
      return 'pt_BR';
    case 'zh-cn':
      return 'zh_CN';
    case 'zh':
    case 'zh-tw':
      return 'zh_TW';
    default:
      return lang;
  }
}
export function getInitialScriptLoading() {
  var _HSGlobalNav;
  return !((_HSGlobalNav = window.HSGlobalNav) !== null && _HSGlobalNav !== void 0 && _HSGlobalNav.load);
}
export function getInitialCssLoading() {
  return !document.getElementById(MARKETING_EMBED_NAV_CSS_ID);
}